export const displayNewLineStyles = {
  whiteSpace: 'pre-line',
};
